export const CustomerTypes = {
    GET_CREATE_CUSTOMER: "GET_CREATE_CUSTOMER",
    CLEAR_CREATE_CUSTOMER: "CLEAR_CREATE_CUSTOMER",
}